"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var Placeholder_less_1 = __importDefault(require("stremio/routes/Library/Placeholder/Placeholder.less"));
var Placeholder = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: Placeholder_less_1.default['placeholder'] },
        react_1.default.createElement("div", { className: Placeholder_less_1.default['title'] }, t('CALENDAR_NOT_LOGGED_IN')),
        react_1.default.createElement("div", { className: Placeholder_less_1.default['image-container'] },
            react_1.default.createElement(components_1.Image, { className: Placeholder_less_1.default['image'], src: require('/assets/images/calendar_placeholder.png'), alt: ' ' })),
        react_1.default.createElement("div", { className: Placeholder_less_1.default['overview'] },
            react_1.default.createElement("div", { className: Placeholder_less_1.default['point'] },
                react_1.default.createElement(react_2.default, { className: Placeholder_less_1.default['icon'], name: 'megaphone' }),
                react_1.default.createElement("div", { className: Placeholder_less_1.default['text'] }, t('NOT_LOGGED_IN_NOTIFICATIONS'))),
            react_1.default.createElement("div", { className: Placeholder_less_1.default['point'] },
                react_1.default.createElement(react_2.default, { className: Placeholder_less_1.default['icon'], name: 'calendar-thin' }),
                react_1.default.createElement("div", { className: Placeholder_less_1.default['text'] }, t('NOT_LOGGED_IN_CALENDAR')))),
        react_1.default.createElement("div", { className: Placeholder_less_1.default['button-container'] },
            react_1.default.createElement(components_1.Button, { className: Placeholder_less_1.default['button'], href: '#/intro?form=login' }, t('LOG_IN')))));
};
exports.default = Placeholder;
